export const baseURL: string = __API_BASE_URL__;
export const mobileEndpoint: string = '/wp-json/birds/v1/mobile';
export const editorEndpoint: string = '/wp-json/birds/v1/editor';
export const verbiEndpoint: string = '/wp-json/birds/v1/verbi';
export const moderationEndpoint: string = '/wp-json/birds/v1/mobile/moderation';
export const wpPostsEndpoint: string = "/wp-json/wp/v2/posts";
export const wpUsersEndpoint: string = "/wp-json/wp/v2/users";
export const wpCommentsEndpoint: string = "/wp-json/wp/v2/comments";
export const pushEndpoint: string = '/wp-json/birds-push/v1';
export const huntEndpoint: string = '/wp-json/birds/v1/hunt';